// extracted by mini-css-extract-plugin
export default {"container":"tp-z","ratingLayout":"up-z","ratingLabel":"vp-z","nonInteractiveRatingLabel":"wp-z"};